import Vue from 'vue';
import VueI18n from 'vue-i18n';

Vue.use(VueI18n);

let defaultLanguage = '';
const config = window.cConfig;
let allowMultipleLanguages = false;
let enabledLanguageKeys = [];
const programLanguageSettings = config?.programs?.reduce((supportedLanguageKeys, currProgram) => {
  const languageSettings = currProgram.programSettings.find(setting => setting.key === 'byodMultipleLanguages' && setting.value);

  languageSettings?.languages.forEach((language) => {
    if (!supportedLanguageKeys.includes(language.key)) supportedLanguageKeys.push(language.key);
  });
  return supportedLanguageKeys;
}, []);

if (programLanguageSettings?.length) {
  allowMultipleLanguages = true;
  enabledLanguageKeys = Array.from(new Set(programLanguageSettings));
} else {
  // fall back to commonSettings for backwards compatibility
  const languageSettings = config?.commonSettings?.find(setting => setting.key === 'byodMultipleLanguages' && setting.value);
  allowMultipleLanguages = !!languageSettings;
  enabledLanguageKeys = languageSettings?.languages.map(({ key }) => key) || [];
}

const selectedLanguage = localStorage.getItem('selectedLanguage');

if (allowMultipleLanguages && selectedLanguage) {
  defaultLanguage = selectedLanguage;
} else if (allowMultipleLanguages && navigator.language.includes('es')) {
  defaultLanguage = 'es';
} else if (allowMultipleLanguages && (navigator.language.includes('fil') || navigator.language.includes('tl'))) {
  defaultLanguage = 'tl';
} else {
  defaultLanguage = 'en';
}

function loadLocaleMessages() {
  const locales = require.context('./locales', true, /[A-Za-z0-9-_,\s]+\.js$/i);
  const messages = {};
  locales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      messages[locale] = locales(key).default;
    }
  });

  const vclLocales = require.context('../node_modules/@virtual-peaker/vue-component-library/src/locales', true, /[A-Za-z0-9-_,\s]+\.js$/i);
  const vclMessages = {};
  const combinedMessages = {};
  vclLocales.keys().forEach((key) => {
    const matched = key.match(/([A-Za-z0-9-_]+)\./i);
    if (matched && matched.length > 1) {
      const locale = matched[1];
      vclMessages[locale] = vclLocales(key).default;
      combinedMessages[locale] = { ...messages[locale], ...vclMessages[locale] };
    }
  });
  return combinedMessages;
}

const i18n = new VueI18n({
  locale: defaultLanguage || 'en',
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  silentTranslationWarn: true,
  messages: loadLocaleMessages(),
});

export default i18n;
export {
  i18n,
  enabledLanguageKeys,
};
